// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function deleteSavedView(ydb: Database, viewId: string): void {
  ydb.mutate((db) => {
    db.deleteView(viewId);
  });
}
